import React from "react";
import { Modal } from "react-bootstrap";

import { Badge, fmtDate } from "./config";

const fmtTime = (d) =>
  d
    ? new Date(d).toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";

// Per-day drill-down for the Employee Daily report — every audit-log item an
// employee touched on one calendar day (call logged, marked paid/recharged,
// modem visit, etc.), shown customer-by-customer. Replaces the old inline
// expand row with a proper modal, per request.
const EmployeeDayModal = ({
  show,
  onClose,
  employeeName,
  employeeRole,
  date,
  title,
  items = [],
  actionLabel = {},
}) => {
  // A bulk audit row (e.g. "Handed over 42 modems") carries the customers it
  // covered — list them one by one instead of a single summary line.
  const flat = items.flatMap((it) =>
    Array.isArray(it.customers) && it.customers.length
      ? it.customers.map((c) => ({
          ...it,
          customerKey: c.customerKey,
          summary: c.name ? `${c.name} — ${it.summary || ""}` : it.summary,
        }))
      : [it],
  );
  return (
  <Modal
    show={show}
    onHide={onClose}
    size="lg"
    centered
    scrollable
    enforceFocus={false}
  >
    <Modal.Header closeButton>
      <Modal.Title className="text-base">
        {employeeName}
        {employeeRole ? (
          <span className="ml-1 text-xs font-normal text-gray-400">
            {employeeRole}
          </span>
        ) : null}
        {title ? (
          <span className="ml-2 text-sm font-semibold text-cyan-700">
            · {title} ({flat.length})
          </span>
        ) : null}
        {date ? (
          <span className="ml-2 text-sm font-normal text-gray-400">
            · {fmtDate(date)}
          </span>
        ) : null}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {flat.length === 0 ? (
        <div className="py-8 text-center text-sm text-gray-400">
          No customer activity logged this day.
        </div>
      ) : (
        <div className="max-h-[28rem] overflow-y-auto rounded-lg border border-gray-200">
          <table className="min-w-full text-sm">
            <thead className="sticky top-0 bg-gray-50">
              <tr className="text-[11px] uppercase tracking-wider text-gray-500">
                <th className="px-3 py-2 text-left">Time</th>
                <th className="px-3 py-2 text-left">Customer</th>
                <th className="px-3 py-2 text-left">Action</th>
                <th className="px-3 py-2 text-left">Summary</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {flat.map((it, i) => (
                <tr key={i} className={i % 2 ? "bg-gray-50" : "bg-white"}>
                  <td className="px-3 py-2 align-top text-xs text-gray-400">
                    {fmtTime(it.at)}
                  </td>
                  <td className="px-3 py-2 align-top font-medium text-gray-800">
                    {it.customerKey || "—"}
                  </td>
                  <td className="px-3 py-2 align-top">
                    <Badge>{actionLabel[it.action] || "Other"}</Badge>
                  </td>
                  <td className="px-3 py-2 align-top text-gray-600">
                    {it.summary || "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Modal.Body>
  </Modal>
  );
};

export default EmployeeDayModal;
